export default __webpack_public_path__ + "static/clean-safe-e047bd9bdc7e2550f27364bb77004622.png";